import { _ } from "../../polyglot/polyglot.js";
import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * Switch button (toggles on/off). No logic yet, just rendering.
 *
 * @param {boolean} [state] - True if the default state is on
 * @param {boolean} [disabled] - True if the switch is disabled and
 *   switched on and off
 * @param {string} [dataTestName] - Value for the "data-test" html
 *   attribute
 * @param {function(boolean): void} [onStateChanged] - Called with the state
 *   of the switch when it changes
 */
export default class SwitchButton extends Widget {
	constructor({
		state = false,
		disabled = false,
		dataTestName = "",
		onStateChanged = () => {},
	} = {}) {
		super(...arguments);

		this._state = state;
		this._disabled = disabled;
		this._dataTestName = dataTestName;

		this.stateChanged = this._events.createEvent();
		this.stateChanged.register(onStateChanged);
	}

	setState(boolean) {
		this._state = boolean;
		this.stateChanged.trigger(this._state);
		this.update();
	}

	reset(boolean) {
		this._state = boolean;
		this.update();
	}

	getState() {
		return this._state;
	}

	isOn() {
		return !!this._state;
	}

	isOff() {
		return !this._state;
	}

	toggle() {
		if (this.isDisabled()) {
			return;
		}
		this.setState(!this._state);
	}

	isDisabled() {
		return this._disabled;
	}

	renderContentOn(html) {
		html.div(
			{
				class: ["switch-btn", { disabled: this.isDisabled() }],
				"data-test": this._dataTestName,
				click: this.toggle.bind(this),
			},
			(html) => {
				if (this._state) {
					html.span({ klass: "switch-on" }, _("On"));
				} else {
					html.span({ klass: "switch-off" }, _("Off"));
				}
			},
		);
	}
}
